<template>
  <div>
    <el-table
      :data="allProductList"
      border
      class="w-full all-product-table-eenhgsjw"
      show-summary
      :summary-method="getAllSummaries"
    >
      <el-table-column
        v-if="!detail"
        type="selection"
        width="50"
      />
      <el-table-column
        prop="itemIndex"
        label="序号"
        align="left"
        width="90"
      />
      <el-table-column prop="orderNumber" label="订单号" align="left" />
      <el-table-column
        prop="materialNumber"
        label="物品代码"
        align="left"
      />
      <el-table-column prop="productName" label="物品名称" align="left" />
      <el-table-column prop="productNum" label="数量" align="left" width="60px" />
      <el-table-column
        prop="productPriceSigle"
        label="实际结算单价"
        align="right"
        header-align="left"
        width="100px"
      />
      <el-table-column
        prop="settlementAmount"
        label="实际结算金额"
        align="right"
        header-align="left"
        width="100px"
      />
      <el-table-column
        prop="freightAttributeName"
        label="货运方式"
        align="left"
        width="100"
      />
      <el-table-column
        prop="expectedDeliveryDate"
        label="客户期望发货日"
        align="left"
        width="140"
      />
      <el-table-column
        prop="agreedDate"
        label="约定交付日期"
        align="left"
        width="140"
      />
      <el-table-column
        prop="deliveryAddress"
        label="收货地址"
        align="left"
        width="200"
      />
      <el-table-column
        prop="expType"
        label="运输方式"
        align="left"
        width="100"
      />
      <el-table-column
        prop="expShop"
        label="承运商"
        align="left"
        width="100"
      />
      <el-table-column
        v-if="!detail"
        label="操作"
        align="left"
        width="100"
      />
    </el-table>
  </div>
</template>
<script>
import { MathAdd } from '@/libs/util';

export default {
  name: 'DialogAddressInnerProduct',
  data () {
    return {
      allProductList: []
    };
  },
  props: {
    detail: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getAllSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      return cont;
    },
    // 实际结算金额总计
    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    setData (parentList) {
      this.allProductList = parentList.map(item => item.productList).flat();
    }
  }
};
</script>

<style lang="scss">

.all-product-table-eenhgsjw{
  margin-top: 16px;
  .el-table__header-wrapper, .el-table__body-wrapper {
    display: none !important;
  }
}
</style>
